import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import './assets/style.css'

Vue.use(ElementUI, { size: 'small' })
Vue.config.productionTip = false

// Custom $t that supports format strings {1}, {2}
const originalT = i18n.t.bind(i18n)
Vue.prototype.$t = function(key, params) {
  if (!params || params.length === 0) return originalT(key)
  let str = originalT(key)
  params.forEach((param, i) => {
    str = str.replace('{' + (i + 1) + '}', param)
  })
  return str
}

// Language switcher
Vue.prototype.$setLang = function(lang) {
  i18n.locale = lang
  const { setLanguage } = require('@/utils/storage')
  setLanguage(lang)
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
